import styled from 'styled-components';
import { ReactComponent as Refresh } from 'Images/reload.svg';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;

  width: 100%;
  min-width: 0;
  margin-bottom: 26px;
`;

export const GroupBySlot = styled.div`
  flex: 1 1 160px;
  min-width: 140px;
  max-width: 320px;
`;

export const RiskScoreProfileSlot = styled.div`
  flex: 1 1 200px;
  min-width: 180px;
  max-width: 320px;
`;

export const ImportanceSlot = styled.div`
  margin-top: 20px;
`;
ImportanceSlot.displayName = 'ImportanceSlot';

export const IconButton = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 26px;
`;
IconButton.displayName = 'IconButton';

export const RefreshIcon = styled(Refresh)`
  width: 28px;
  height: 28px;
  g {
    fill: ${({ theme }) => theme.icons.workspaceRefresh.color};
  }
`;
RefreshIcon.displayName = 'RefreshIcon';
